import { alpha } from '@mui/material/styles';
import type { Components, Theme } from '@mui/material/styles';

import type {} from '@mui/lab/themeAugmentation';

export const buttonComponents: Components<Theme> = {
    MuiButton: {
        defaultProps: {
            disableElevation: true,
        },
        styleOverrides: {
            root: ({ theme }) => ({
                minHeight: 42,
                borderRadius: 12,
                paddingInline: 17,
                fontWeight: 650,
                textTransform: 'none',
                whiteSpace: 'nowrap',
                transition: theme.transitions.create(
                    [
                        'background-color',
                        'background-image',
                        'border-color',
                        'box-shadow',
                        'transform',
                    ],
                    { duration: 160 },
                ),
                '&:active:not(.Mui-disabled)': {
                    transform: 'translateY(1px) scale(0.995)',
                },
            }),
            sizeSmall: {
                minHeight: 36,
                borderRadius: 10,
                paddingInline: 13,
                fontSize: 12,
            },
            sizeLarge: {
                minHeight: 48,
                borderRadius: 13,
                paddingInline: 22,
            },
            startIcon: {
                margin: 0,
                marginInlineEnd: 6,
            },
            endIcon: {
                margin: 0,
                marginInlineStart: 6,
            },
            containedPrimary: ({ theme }) => ({
                color: theme.palette.primary.contrastText,
                backgroundImage: theme.palette.gradientButton.base,
                boxShadow: `0 9px 24px ${alpha(theme.palette.primary.main, 0.2)}`,
                '&:hover': {
                    backgroundImage: theme.palette.gradientButton.hover,
                    boxShadow: `0 12px 30px ${alpha(theme.palette.primary.main, 0.27)}`,
                },
                '&.Mui-disabled': {
                    backgroundImage: 'none',
                },
            }),
            outlined: ({ theme }) => ({
                borderColor: theme.palette.border.main,
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                '&:hover': {
                    borderColor: alpha(theme.palette.primary.main, 0.55),
                    backgroundColor: alpha(theme.palette.primary.main, 0.055),
                },
            }),
            text: ({ theme }) => ({
                '&:hover': {
                    backgroundColor: alpha(theme.palette.primary.main, 0.065),
                },
            }),
        },
    },

    MuiIconButton: {
        styleOverrides: {
            root: ({ theme }) => ({
                borderRadius: 11,
                transition: theme.transitions.create(
                    ['background-color', 'border-color', 'color', 'transform'],
                    { duration: 140 },
                ),
                '&:hover': {
                    backgroundColor: theme.palette.action.hover,
                },
                '&:active': {
                    transform: 'scale(0.96)',
                },
            }),
        },
    },

    MuiFab: {
        styleOverrides: {
            root: ({ theme }) => ({
                boxShadow: `0 12px 32px ${alpha(theme.palette.common.black, 0.18)}`,
            }),
        },
    },

    MuiLoadingButton: {
        styleOverrides: {
            root: ({ theme }) => ({
                '&.Mui-disabled': {
                    color: alpha(theme.palette.text.primary, 0.5),
                },
                '& .MuiLoadingButton-loadingIndicator': {
                    color: theme.palette.primary.light,
                },
                '&.MuiLoadingButton-loading': {
                    color: 'transparent',
                },
            }),
        },
    },
};
